import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy did not have a standalone /account/user/journal route — journal
 * is the second tab inside /medical-vault. Redirect to it for any
 * deep-links the portal sidebar emitted.
 */
export const Route = createFileRoute("/_authenticated/account/user/journal")({
  beforeLoad: () => {
    throw redirect({
      to: "/account/user/medical-vault",
      search: { tab: "journal", subtab: "active" } as never,
    });
  },
});
